export var MuiTextField = {
    variant: 'outlined',
    fullWidth: true,
};
//# sourceMappingURL=MuiTextField.js.map